import { render, staticRenderFns } from "./bet-list.vue?vue&type=template&id=c03a0844&"
import script from "./bet-list.vue?vue&type=script&lang=js&"
export * from "./bet-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports